import { CardDef, DECK } from '../tarot/deck';

/** Public address of the web app, used for canonical links and the sitemap. */
export const SITE_URL = (
    process.env.REACT_APP_SITE_URL ||
    'https://blue-coast-0edc77010.1.azurestaticapps.net'
).replace(/\/$/, '');

const MAJOR = [
    'the-fool',
    'the-magician',
    'the-high-priestess',
    'the-empress',
    'the-emperor',
    'the-hierophant',
    'the-lovers',
    'the-chariot',
    'strength',
    'the-hermit',
    'wheel-of-fortune',
    'justice',
    'the-hanged-man',
    'death',
    'temperance',
    'the-devil',
    'the-tower',
    'the-star',
    'the-moon',
    'the-sun',
    'judgement',
    'the-world',
];

const RANKS = [
    'ace',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
    'page',
    'knight',
    'queen',
    'king',
];

/** The English slug of a card, which is the address of its page in every language: `the-fool`, `ace-of-wands`. */
export const cardSlug = (card: CardDef): string =>
    card.arcana === 'major'
        ? MAJOR[card.rank]
        : `${RANKS[card.rank - 1]}-of-${card.suit}`;

const BY_SLUG = new Map(DECK.map((c) => [cardSlug(c), c]));

export const cardBySlug = (slug: string | undefined): CardDef | undefined =>
    slug ? BY_SLUG.get(slug) : undefined;

export const CARD_PATH = '/tarot-card-meanings';
export const cardPath = (card: CardDef): string =>
    `${CARD_PATH}/${cardSlug(card)}`;
export const chironSignPath = (sign: string): string => `/chiron-in/${sign}`;

/** The landing pages that are not one of many (a card, a sign). */
export const LANDING = [
    'free-birth-chart',
    'whats-your-birth-chart',
    'chiron-sign-calculator',
    'chiron-in-astrology',
] as const;
export type LandingId = (typeof LANDING)[number];
